// extracted by mini-css-extract-plugin
export default {"usernameColumn":"usernameColumn-GjeRgVPw","statusColumn":"statusColumn-O9PvIKRK","activityColumn":"activityColumn-cyFwusFP","actionColumn":"actionColumn-AcvMlbc9"};